import type { WorkbookDefinition } from '@erp/shared-types';
import { outputSheetIds, workbookDependencies } from '@erp/workbooks';

type Named = { id: string; name: string };

/**
 * What reads a Worksheet directly: the other Worksheets that take it as their
 * input or a Lookup's source, and the Outputs that export, sink or chart it.
 * Removing the Worksheet leaves them without it.
 */
export function workbookSheetDependents(
  definition: WorkbookDefinition,
  sheetId: string,
): { sheets: Named[]; outputs: Named[] } {
  const dependencies = workbookDependencies(definition);
  const sheets: Named[] = [];
  for (const { id, name } of definition.sheets) {
    if (id !== sheetId && new Set(dependencies.get(id)).has(sheetId))
      sheets.push({ id, name });
  }
  const outputs: Named[] = [];
  for (const output of definition.outputs) {
    if (new Set(outputSheetIds(definition, output)).has(sheetId))
      outputs.push({ id: output.id, name: output.name });
  }
  return { sheets, outputs };
}
